import { del as idbDelete } from 'idb-keyval';

export const remove = async (idbKey) => {
    try {
        await idbDelete(idbKey);
    } catch (error) {
        console.error(`Could not delete key ${idbKey}`, { error });
    }
};


